export const INSPECTIONS_TYPE_For_API = {
  all: "",
  new_report: "new_report",
  under_review: "under_manager_review",
  final_review: "under_editor_final_review",
  ready_for_distribution: "ready_for_distribution",
  archived: "archived",
  "": "",
  undefined: "",
};

export const INSPECTIONS_TYPE_URL = {
  All: "all",
  "New Report": "new_report",
  "Under Review": "under_review",
  "Final Review": "final_review",
  "Ready For Distribution": "ready_for_distribution",
  Archived: "archived",
  undefined: "",
};

export const INSPECTIONS_TYPE_REVERSED = {
  undefined: "All",
  "": "All",
  all: "All",
  undefined: "All",
  new_report: "New Report",
  under_review: "Under Review",
  final_review: "Final Review",
  ready_for_distribution: "Ready For Distribution",
  archived: "Archived",
};

export const CONVERT_TO_BOOLEAN = {
  "true": true,
  "false": false,
};
